import styled, { css } from 'styled-components'

import { mapProps } from '../theme/mapProps'
import { userSelectButton, mapMarginPaddingProps } from '../theme/rules'

export const Block = styled.div`
  ${({ to, href, onClick, onTouchTap }) => (to || href || onClick || onTouchTap) && userSelectButton};

  ${mapProps({
    width: {
      auto: css`
        width: auto;
        max-width: auto;
      `,
      min: css`
        width: min-content;
        min-width: min-content;
        max-width: min-content;
      `,
      max: css`
        width: max-content;
        min-width: max-content;
        max-width: max-content;
      `
    },
  })}

  ${mapMarginPaddingProps};
`

export default Block



// WEBPACK FOOTER //
// ./src/styleguide/Block.js